import {trackEvent, type TrackEvent} from "@atg-shared/analytics";

import type {SportTrackingEvent} from "@atg-sport-shared/analytics-types";

export const trackSportEvent: TrackEvent<SportTrackingEvent> = trackEvent;
